import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const FooterRoot = styled.footer`
  width: 100%;
  // background: #262626;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, #1a1a1a 0%, #121212 100%);
`;

export const FooterInner = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 48px 24px 28px;

  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Links = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

/** ✅ Внутренние ссылки (react-router) */
export const FooterLink = styled(Link)`
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 18px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #d6c6a5;
  // color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  width: fit-content;

  &:hover {
    color: #ffffff;
  }
`;

/** ✅ Внешняя ссылка (instagram) */
export const FooterExternalLink = styled.a`
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 18px;
  letter-spacing: 0.6px;
  text-transform: uppercase;

  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  width: fit-content;

  &:hover {
    color: #ffffff;
  }
`;

export const LangSwitch = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
`;

export const FlagButton = styled.button`
  width: 32px;
  height: 22px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 22px;
  line-height: 1;

  opacity: 0.75;

  &:hover {
    opacity: 1;
  }
`;
